export type PrepOrigin = 'incoming' | 'outgoing'

export interface PrepLocationState {
  from?: PrepOrigin
}

export function parsePrepOrigin(value: unknown): PrepOrigin | null {
  if (value === 'incoming' || value === 'outgoing') return value
  return null
}

export function getPrepPagePath(requestId: string, origin: PrepOrigin): string {
  return `/teacher/request/${requestId}/prep?from=${origin}`
}

export function resolvePrepOrigin(args: {
  origin?: PrepOrigin | null
  currentTeacherId?: string | null
  requestingTeacherId?: string | null
}): PrepOrigin {
  if (args.origin === 'incoming' || args.origin === 'outgoing') {
    return args.origin
  }
  if (
    args.currentTeacherId
    && args.requestingTeacherId
    && args.currentTeacherId === args.requestingTeacherId
  ) {
    return 'outgoing'
  }
  return 'incoming'
}

export function getPrepBackPath(args: {
  requestId: string
  origin?: PrepOrigin | null
  currentTeacherId?: string | null
  requestingTeacherId?: string | null
}): string {
  const origin = resolvePrepOrigin(args)
  const listPath = origin === 'incoming'
    ? '/teacher/incoming-requests'
    : '/teacher/requests'
  return `${listPath}?highlight=${encodeURIComponent(args.requestId)}`
}

export function getPrepListLabel(origin: PrepOrigin): string {
  return origin === 'incoming' ? 'Anfragen an mich' : 'Anfragen von mir'
}
